<template>
  <div class="drugwheel" id="wheel">
    <div class="container">
      <h1 class="title is-1 drugs__title">{{ title }}</h1>
      <div class="container content">
        <div class="drugwheel__intro" v-html="intro"></div>
      </div>
    </div>
    <div
      class="drugwheel__control is-ccw"
      @click="rotateWheel('ccw')"
    ></div>
    <div
      class="drugwheel__control is-cw"
      @click="rotateWheel('cw')">
    </div>
    <div class="drugwheel__wheel">
      <div class="drugwheel__container" ref="wheel">
        <wheel-svg @drug-clicked="loadDrug" @effect-clicked="loadEffect"></wheel-svg>
      </div>
    </div>
    <div class="container content">
      <div class="drugwheel__about" v-html="aboutWheel"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sendGaEvent } from '@/utils';
import WheelSvg from '@/components/svg/wheel.vue';

export default {
  name: 'drugwheel',
  components: { WheelSvg },
  props: ['pageId', 'title'],
  data() {
    return {
      wheel: {},
      drug_type_count: 7,
      rotate_count: 0,
      rotate_value: 1,
      default_position: 1,
      new_position: 1,
      intro: '',
      aboutWheel: '',
    };
  },
  mounted() {
    // Wheel
    this.wheel = this.$refs.wheel;
    // Rotation
    this.rotate_count = 0;
    this.rotate_value = 360 / this.drug_type_count;
    this.default_position = this.rotate_value / 2;
    this.new_position = this.rotate_value / 2;

    axios.get(`${process.env.VUE_APP_API_URL}pages/${this.pageId}/`)
      .then((response) => {
        this.intro = response.data.intro;
        this.aboutWheel = response.data.about_wheel;
      });
  },
  methods: {
    /**
    * Rotates wheel
    * @param {String} direction - Control clicked event
    */
    rotateWheel(direction) {
      if (this.rotate_count > 0) {
        if (direction === 'cw') {
          this.new_position += this.rotate_value;
        } else {
          this.new_position -= this.rotate_value;
        }
      } else if (this.rotate_count === 0) {
        if (direction === 'ccw') {
          this.new_position = -(this.rotate_value + this.default_position);
        }
      }
      this.wheel.style.transform = `rotate(${this.new_position}deg)`;
      this.rotate_count += 1;
    },
    /**
     * get drug url and redirect users there
     */
    loadDrug(slug) {
      window.location.pathname = window.location.pathname + slug; // eslint-disable-line operator-assignment,max-len
      sendGaEvent('Drug Wheel', 'wheel', `Drug - ${slug}`);
    },
    /**
     * get effect url and redirect users there
     */
    loadEffect(slug) {
      window.location.pathname = window.location.pathname + slug; // eslint-disable-line operator-assignment,max-len
      sendGaEvent('Drug Wheel', 'wheel', `Drug type - ${slug}`);
    },
  },
};
</script>
